<script>
export default {
  name: 'FundraiserPageRaisedAmount',
  props: {
    fundraiserPage: {
      type: Object,
      required: true
    }
  },
  computed: {
    textSizeRaisedAmount() {
      return 'text-5xl'
    },
    raisedFormatted() {
      return this.$filters.formatCurrency(this.fundraiserPage.cached?.raised, this.fundraiserPage.currency)
    },
    goalFormatted() {
      return this.$filters.formatCurrency(this.fundraiserPage.goal, this.fundraiserPage.currency)
    },
  }
}
</script>

<template>
  <div class="flex flex-wrap gap-2 justify-between items-end mb-2">
    <h2 class="text-2xl lg:text-3xl font-medium">
      {{ raisedFormatted }}
    </h2>
    <span class="text-sm font-medium mb-[2px]">
      {{ fundraiserPage.cached.percentage_raised }}% of {{ goalFormatted }} goal
    </span>
  </div>
</template>

<style scoped>

</style>
